import React from "react";
import { useAppContext } from "../../AppProvider";
import InputBoxIcon from "../../Components/Inputs/InputIcon/InputIcon";
import { Parcel } from "../../Models/Parcel";
import {
  faCube,
  faRuler,
  faRulerHorizontal,
  faRulerVertical,
  faWeightHanging,
} from "../../utilities/fontawesomeIcons";
import { responsiveParcels } from "./Layout/ResponsiveParcels";

export const ParcelListItem: React.FC<{
  listRef: React.RefObject<{
    refresh: () => void;
  } | null>;
  item: Parcel;
  index: number;
}> = React.memo(({ item }) => {
  const { dictionary, display } = useAppContext();

  const styles = responsiveParcels(display);

  return (
    <>
      <div
        data-grid-template="parcelsList"
        className="gap-2 rounded-2 p-2 align-items-center mb-2"
        style={{ ...styles.listItem, border: "1px solid #eee" }}
      >
        <div style={styles.cells.internalReference}>
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.references.internal_reference}
            </label>
          )}
          <InputBoxIcon
            name="internalReference"
            value={item.internalReference || "-"}
            type="text"
            disabled
          />
        </div>
        <div style={styles.cells.width}>
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.width + " (cm)"}
            </label>
          )}
          <InputBoxIcon
            name="width"
            value={item.width || 0}
            type="positive-number"
            placeholder="10.00"
            icon={faRulerHorizontal}
            disabled
          />
        </div>
        <div style={styles.cells.length}>
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.length} (cm)
            </label>
          )}
          <InputBoxIcon
            name="length"
            value={item.length || 0}
            type="positive-number"
            min={0}
            placeholder="10.00"
            icon={faRuler}
            disabled
          />
        </div>
        <div style={styles.cells.height}>
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.height} (cm)
            </label>
          )}
          <InputBoxIcon
            name="height"
            value={item.height || 0}
            type="positive-number"
            min={0}
            placeholder="10.00"
            icon={faRulerVertical}
            disabled
          />
        </div>
        <div style={styles.cells.weight}>
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.weight} (Kg)
            </label>
          )}
          <InputBoxIcon
            name="weight"
            value={item?.weight || 0}
            type="positive-number"
            icon={faWeightHanging}
            disabled
          />
        </div>
        <div style={styles.cells.volume}>
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.volume} (m<sup>3</sup>)
            </label>
          )}
          <InputBoxIcon
            name="volume"
            value={item?.volume || 0}
            type="positive-number"
            precision={6}
            icon={faCube}
            disabled
          />
        </div>
      </div>
    </>
  );
});
